// see MY RESERVATION
// "MAKE A RESERVATION" button


import React from "react";
import { toBool } from "../../JS/utility";
import { formatMinutesToTimeFormat } from "../../JS/utility";
import { bookMyActivity } from "../../../action/activityBooking";
import { useEffect, useState } from "react";
import Loader from "../../UI/loader";
import { setGoHome, setLoader } from "../../action/homeAction";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { getMyActivities } from "../../../action/activityBooking";
import moment from "moment";
import { CMSPath } from "../../../config/constant";
import { sendAnalytics } from "../../../action/homeAction";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import { scrollToTop } from "../../../JS/scrollToTop";





function Activities5(props) {


const {t}=props 
    const [showLoader, setShowLoader]=useState(false)
    let label = getDefaultAnalyticsLabel({
        appVersion: props.installedAppVersion
            ? `${props.installedAppVersion}(${props.installedAppBuildNo})`
            : "",
    });
    let widgetSesstionId = localStorage.getItem("activityBookingSessionToken");

    const handleNext = () => {

        setShowLoader(true);

        //API CALLING 
        // setActivitiesAvailable
        const payload = {
            "serviceType": "activity",
            "appointmentId": props.bookingData.selectedActivity.appointmentId,
            "totalGuests": props.bookingData.totalGuests, // Main guest + additional guests
            "activityPrice": props.bookingData.selectedActivity.price
        }

        bookMyActivity(payload)
            .then((res) => {
                if (res.status == 200 && (res && res.data && res.data.header && res.data.header.status && res.data.header.status.code == "SUCCESS") && (res.data.payload && res.data.payload.data && res.data.payload.data.ConfirmationId)) {
                    sendTheAnalytics(true)

                    let cachedData = props.cachedApiDataStore["my_reservations"];
                    delete cachedData[`my_reservations_${props.bookingData.spaLocationId}`];
                    props.setCachedApiDataStore({ ...props.cachedApiDataStore, "my_reservations": cachedData })

                    props.next( )

                } else {
                    props.closeOrderPopUp(true,
                        res && res.data && res.data.header && res.data.header.status && res.data.header.status.msg || t("activityBooking.error.bookMyActivity"),
                        "", true);
                    sendTheAnalytics(false)

                }

            })

            .catch(() => {
                props.closeOrderPopUp(true, t("activityBooking.error.bookMyActivity"), "", true);

            })

            .finally(() => {
                setShowLoader(false)
            })
    }

    const sendTheAnalytics = (isSuccess) => {
        try {

            props.sendAnalytics(
                props.guestDetail,
                props.currentWidgets.widgetType,
                isSuccess ? "   SAVE APP. ACTIVITY - SUCCESS" : "SAVE APP. ACTIVITY  - FAIL",
                { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId },
                0,
                props.guestIsLoggedIn
            );
        } catch (error) {
            return error;
        }

    }



useEffect(()=>{
    console.log("test", typeof (props.bookingData.selectedActivity.locationDefaultPrice),props.bookingData.selectedActivity)
},[]) 
    useEffect(() => {
        scrollToTop();
    }, [])

    return (
        <>
            <header className="inner-pages w-footer subpages">
                <a className="button-back" onClick={() => props.handleGoBack()}></a>
                <div className="heading align-center">
                    <div class="splash-brand">
                        <img src={`${CMSPath}${props.logo}`} />
                    </div>
                </div>
            </header>

            <section class="widgets spa-listing spa-details">
                <div class="widget-header">
                    {props.currentWidgetObj.widgetHeaderImageUrl && (
                        <div class="widget-header-img">
                            <img
                                src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`}
                                alt={props.currentWidgetObj.displayName}
                            />
                        </div>
                    )}
                    <div class="widget-header-title">{t("activityBooking.summary")}</div>
                </div>

                <div class="detail-body stay-body">
                    <div class="stay-info">
                        <div class="stay-arrival">
                            <div class="heading">{t("activityBooking.date")}</div>
                            <div class="body">
                                <p>
                                    {" "}
                                    {
                                        moment(props.bookingData.selectedActivity.date).format((props.dateFormat).toUpperCase())
 
                                    }


                                </p>
                            </div>
                        </div>
                        <div class="stay-arrival">
                            <div class="heading">{t("activityBooking.time")}</div>
                            <div class="body">
                                <p>

                                    {
                                        formatMinutesToTimeFormat(props.bookingData.selectedActivity.startTime, toBool(props.timeFormat))
                                    }
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <div class="detail-body stay-body">
                            <form>
                                <div class="form-row spa-summary">
                                    <p class="heading">{t("activityBooking.details")}</p>
                                     {/* locationName
                                     serviceName
                                    technicianName
                                    duration
                                    price
                                    locationDefaultPrice */}

                                    <label>
                                        {t("activityBooking.locationName")} <span>{props.bookingData.selectedActivity.locationName}</span>
                                    </label>
                                    <label>
                                        {t("activityBooking.serviceName")} <span>{props.bookingData.selectedActivity.serviceName}</span>
                                    </label>
                                    <label>
                                        {t("activityBooking.duration")}{" "}
                                        <span>{props.bookingData.selectedActivity.duration} {t("activityBooking.min")}</span>
                                    </label>
                                    <label>
                                        {t("activityBooking.therapist")}{" "}
                                        <span>
                                            {props.bookingData.selectedActivity.technicianName}
                                        </span>
                                    </label>
                                </div>

                                {/* {
                                   
                                <div class="form-row price-total">
                                    <label>
                                                {t("activityBooking.activity_cost")}
                                        <span>
                                            {props.currencyCode}{" "}
                                                    {props.bookingData.selectedActivity.locationDefaultPrice}
                                        </span>
                                    </label>
                                </div>
                                } */}


                                {/* {
                                   
                                <div class="form-row price-total">
                                    <label>
                                                {t("activityBooking.activity_cost")}
                                        <span>
                                            {props.currencyCode}{" "}
                                                    {props.bookingData.selectedActivity.price * props.bookingData.totalGuests}
                                        </span>
                                    </label>
                                </div>

                                } */}

                                <div class="form-row price-total">
                                    <label>
                                        {t("activityBooking.activity_price")}
                                        <span>
                                            {props.currencyCode}{" "}
                                            {`${(props.bookingData.selectedActivity.price)}/person`}
                                        </span>
                                    </label>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                 <div class="row">
                    <div class="form-controls">
                        <button onClick={handleNext}>
                            {props.updateReservationDetails ? t("activityBooking.update_reservation_button") : t("spaBooking.make_reservation")}
                        </button>
                        <button onClick={props.handleGoBack}>{t("activityBooking.back")}</button>
                    </div>
                </div>  
            </section>

            {
                showLoader && <Loader displayMsg={t("activityBooking.loader_msg.bookmyactivity")} /> // check whether to show close button, 
            }                                 
        </>
    )
}
const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        timeFormat:
            state.store.home.clientConfig.extraConfigParam &&
            state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
        dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
            : "",
        currencyCode: state.store.home.clientConfig.currencyDetails
            ? state.store.home.clientConfig.currencyDetails.code
            : "",
    }
}

const mapDispatchToProps = { setGoHome, closeOrderPopUp, sendAnalytics }

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('translations')(Activities5));


// {
//     `${props.bookingData.selectedActivity.locationDefaultPrice &&
//         props.bookingData.selectedActivity.locationDefaultPrice > 0
//         ?
//         (props.bookingData.selectedActivity.price * props.bookingData.totalGuests) +
//         props.bookingData.selectedActivity.locationDefaultPrice

//         :
//         (props.bookingData.selectedActivity.price * props.bookingData.totalGuests)

//     }`
// }